<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold">{{ widget?.name }}</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>

<div class="modal-body">
  @if (widget) {
    <app-widget-viewer [widget]="widget"></app-widget-viewer>
  }
</div>
